import React, { createContext, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const FlyoutTitleContext = createContext(null);
export const FlyoutContentContext = createContext(null);
export const FlyoutFooterContext = createContext(null);

export const FlyoutContext = createContext(null);
export const FlyoutProvider = ({ children }) => {
  const [openFlyoutId, setOpenFlyoutId] = useState(null);

  const openFlyout = useCallback(id => {
    setOpenFlyoutId(id);
  }, []);

  const closeFlyout = useCallback(() => {
    setOpenFlyoutId(null);
  }, []);

  const value = useMemo(() => ({ openFlyoutId, openFlyout, closeFlyout }), [openFlyoutId, openFlyout, closeFlyout]);

  return <FlyoutContext.Provider value={value}>{children}</FlyoutContext.Provider>;
};

FlyoutProvider.propTypes = {
  children: PropTypes.node,
};
